import { EntityType, MapEntity } from "@mapmycustomers/shared/types/entity";
import { convertLongLatToLatLngLiteral } from "@mapmycustomers/shared/util/geo/GeoService";

const defaultMapEntityGeometryGetter = (
  entity: MapEntity
): Exclude<google.maps.Data.FeatureOptions["geometry"], undefined> => {
  const geoPoint =
    entity.entity === EntityType.DEAL
      ? entity.account?.geoPoint || entity.contact?.geoPoint
      : entity.geoPoint;
  return new google.maps.Data.Point(convertLongLatToLatLngLiteral(geoPoint!.coordinates));
};

export default defaultMapEntityGeometryGetter;
